export const GET_ERROR = "GET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
